import { history } from 'middleware'

const getUrlObject = () => new URL(window.location.href)

// Pure parser for a location hash string ('#route?a=b' → 'route'), for
// callers that track the hash reactively (e.g. via useLocation).
export const parseHashRoute = (hash: string): string => hash.slice(1).split('?')[0]

export const getHash = () => {
    const url = getUrlObject()
    const hashParts = url.hash.slice(1).split('?')
    const route = hashParts[0]
    const params = hashParts[1] ? new URLSearchParams(hashParts[1]) : new URLSearchParams()
    return { route, params }
}

export const setHash = (hash: string, params: Record<string, string> | URLSearchParams = {}) => {
    const url = getUrlObject()
    const paramString = new URLSearchParams(params).toString()
    url.hash = `${hash}${paramString ? `?${paramString}` : ''}`
    history.replace(`${url.pathname}${url.search}${url.hash}`)
}

export const removeHash = () => setHash('')

export const getHashRoute = () => getHash().route

export const setHashRoute = (route: string) => {
    const currentHash = getHash()
    setHash(route, currentHash.params)
}

export const getHashParam = (param: string) => {
    const params = getHash().params
    return params.get(param) ?? undefined
}

export const setHashParam = (param: string, value: string) => {
    const currentHash = getHash()
    const params = currentHash.params
    params.set(param, value)
    setHash(currentHash.route, params)
}

export const removeHashParam = (param: string) => {
    const currentHash = getHash()
    const params = currentHash.params
    params.delete(param)
    setHash(currentHash.route, params)
}

export const hashUtils = {
    getHash,
    setHash,
    removeHash,
    getHashRoute,
    setHashRoute,
    getHashParam,
    setHashParam,
    removeHashParam,
}

export default hashUtils
